module.exports = __webpack_public_path__ + "static/img/banner.5cd103b.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/banner.png
// module id = XD8J
// module chunks = 2